<div class="chart-container">
  <h3 class="chart-title">{{ title }}</h3>
  <div class="chart-wrapper">
    <canvas type="line" [data]="lineChartData" [options]="lineChartOptions" baseChart> </canvas>
  </div>
</div>
